import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminBulkImages from "@/pages/admin/AdminBulkImages";

export const Route = createFileRoute("/admin/bulk-images")({
  component: () => (
    <ProtectedRoute>
      <AdminBulkImages />
    </ProtectedRoute>
  ),
});
